export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            关于吃瓜官网
          </h2>
          <p className="text-foreground-500 text-base">51吃瓜官网 — 你的娱乐资讯第一站</p>
        </div>
        <div className="bg-background-100 rounded-3xl p-8 md:p-12 border border-background-200/70">
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-4">
            <strong className="text-foreground-900">吃瓜官网</strong>是51吃瓜官网旗下的专业娱乐资讯聚合平台，致力于为广大网友提供<strong className="text-foreground-900">全网最新吃瓜资讯</strong>。从<strong className="text-foreground-900">今日吃瓜</strong>到<strong className="text-foreground-900">本周热门瓜</strong>，从实时八卦到深度分析，我们覆盖娱乐圈的每一个角落。
          </p>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-4">
            我们的编辑团队来自资深娱乐媒体人、专业娱评人和热情吃瓜爱好者，凭借敏锐的嗅觉和专业的判断，确保每一条<strong className="text-foreground-900">新鲜瓜料</strong>都经过交叉验证，为您呈现最真实可靠的娱乐资讯。无论是明星恋情、综艺路透、影视动态还是音乐新作，<strong className="text-foreground-900">51吃瓜官网在线</strong>都是你不可错过的吃瓜圣地。
          </p>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
            自上线以来，吃瓜官网凭借快速的更新节奏和丰富的内容生态，已成为国内领先的吃瓜资讯平台之一。我们始终坚持&quot;真实、快速、全面&quot;的原则，致力于打造最优质的吃瓜体验。
          </p>
        </div>
      </div>
    </section>
  );
}